export default __webpack_public_path__ + "static/media/125.bd4c08e2.jpg";